<div class="common-header-flex">
  <div>Add User</div>
  <ng-icon name="tablerX" id="add_user_close_button_1" class="svg-position common-close" style="margin-right: 5px;" (click)="closeModal()"></ng-icon>
</div>

<div class="modal-body" [formGroup]="userForm">
  <div class="col-mb-12">
    <div  class="row mb-9 "></div>
    <div class="row mb-3 " style="justify-content: flex-end; margin-right: 5px; display: flex;">
      <button id="add_user_add_field_button" type="button" class="btn  btn-primary" (click)="pushUserFields()"> + Add User
      </button>
    </div>
  </div>


  <ng-container formArrayName="usersList">
    <ng-container *ngFor="let user of userFormArr?.controls; let i = index">
      <div class="row  " [formGroupName]="i">
        <div class="col-lg-2">
          <div class="form-group">
            <label class="col-lg-6 col-sm-2 ft-wt-400 p-0 "> FirstName<span style="color: red;">*</span></label>
            <input class="form-control" (keypress)="checkspace($event)" maxlength="21" type="text"
              placeholder="First name" formControlName="firstName">
            <div class="text-danger"
              *ngIf=" user.get('firstName')?.invalid &&  (user.get('firstName')?.dirty || user.get('firstName')?.touched) ">
              <div *ngIf="user.get('firstName').errors?.required">
                First name is required
              </div>
              <div *ngIf="user.get('firstName')?.errors?.minword">
                {{FORMERROR.FIRSTNAME_MIN}}
              </div>
              <div *ngIf="user.get('firstName')?.errors?.maxword">
                {{FORMERROR.FIRSTNAME_MAX}}
              </div>
              <div *ngIf="user.get('firstName').errors?.pattern&&!user.get('firstName').errors?.maxword">
                Enter only alphabets
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-2">
          <div class="form-group">
            <label class="col-lg-6 col-sm-2 ft-wt-400 p-0">LastName<span style="color: red;">*</span></label>
            <input (keypress)="checkspace($event)" maxlength="41" class="form-control" type="text"
              placeholder="Last name" maxlength="41" formControlName="lastName">
            <div class="text-danger"
              *ngIf=" user.get('lastName')?.invalid &&  (user.get('lastName')?.dirty || user.get('lastName')?.touched) ">
              <div *ngIf="user.get('lastName').errors?.required">
                Last name is required
              </div>
              <div *ngIf="user.get('lastName').errors?.minword">
                {{FORMERROR.LASTNAME_MIN}}
              </div>
              <div *ngIf="user.get('lastName').errors?.maxword">
                {{FORMERROR.LASTNAME_MAX}}
              </div>
              <div *ngIf="user.get('lastName').errors?.pattern&&!user.get('lastName').errors?.maxword">
                Enter only alphabets
              </div>
            </div>
          </div>
        </div>
      <div class="col-lg-2">
  <div class="form-group" [attr.title]="getRoleName(user.get('userType')?.value)">
    <label class="col-lg-6 col-sm-2 ft-wt-400 p-0">Role<span style="color: red;">*</span></label>
    <ng-select
              (change)="onRoleChange($event, i)"
              placeholder="Select Role"
              class="gs-transfer-select"
              style="border: unset !important;width: 100%;"
              formControlName="userType"
              [items]="roles"
              [clearable]="true"
              bindLabel="name"
              bindValue="value"
              appendTo=".gs-add-user-modal"
              >

              <ng-template ng-option-tmp let-item="item">
                <div class="custom-option multi-line-option" [attr.title]="item.name">
                  {{ item.name }}
                </div>
              </ng-template>

              <ng-template ng-label-tmp let-item="item" let-index="index" let-clear="clear">
                <div class="custom-option single-line-truncate" [attr.title]="item.name">
                   
                  {{ item.name.length > 10 ? (item.name | slice:0:10) + '...' : item.name }}
                </div>
              </ng-template>
              <!-- <ng-option *ngFor="let role of roles" [value]="role.value">
                {{ role.name }}
              </ng-option> -->

            </ng-select>

            <div *ngIf="user.get('userType')?.invalid && (user.get('userType')?.dirty || user.get('userType')?.touched)"
              class="text-danger">
              <div *ngIf="user.get('userType').errors?.required">Role is required</div>
            </div>
          </div>
        </div>


         <div class="col-lg-5">
          <div class="form-group">
            <!-- <label class="col-lg-12 col-sm-3 ft-wt-400 p-0">
              Email Address<span style="color: red;">*</span>
            </label> -->
            <label class="col-lg-6 col-sm-2 ft-wt-400 p-0">
  Email Address<span style="color: red;">*</span>
</label>

            <div class=" col-lg-12 col-sm-3 ft-wt-400 p-0">
              <div class="flex">
                <input  class="form-control" type="text" placeholder="Enter email address"   maxlength="51"
                  formControlName="email" (input)="onEmailChange()" (keydown)="preventInput($event)" >
                <input maxlength="51" class="form-control" type="text" value="{{domainMail}}" disabled
                  style="pointer-events: none; border: none; background-color: #e9ecef; width: 150px;">
              </div>

              <div class="text-danger"
                *ngIf="user.get('email')?.invalid && (user.get('email')?.dirty || user.get('email')?.touched) ">
                <div *ngIf=" user.get('email').errors?.required">
                  Email address is required
                </div>

                <div *ngIf="user.get('email').errors?.duplicatesFound">
                  Duplicate emails
                </div>
                <div *ngIf="user.get('email').errors?.emailBlocked">
                  Email input is not allowed
                </div>

                <div *ngIf="user.get('email').errors?.maxlength">
                  Maximum of {{EMAIL?.max}} characters allowed
                </div>
                <div *ngIf="user.get('email').errors?.existMail">
                  Email already taken
                </div>
                <div *ngIf="user.get('email').errors?.pattern&&!user.get('email').errors?.maxlength">
                  Enter valid email address
                </div>

              </div>
            </div>

          </div>

        </div>

        <div class="col-lg-1 p-0 svg-trash addform-delete" *ngIf="i!=0" (click)="removeUser(i)">
          <ng-icon name="tablerTrash" class="svg-position common-close"></ng-icon>
        </div>
      </div>
    </ng-container>

  </ng-container>

  <div class="text-danger text-right m-12" *ngIf="domainMisMatch ">
    Email domain mismatch
  </div>

</div>


<div class="modal-footer">
  <button id="add_user_cancel_button" type="button" class="btn btn-default w70" (click)="closeModal()">Cancel</button>
  <button id="add_user_save_button" type="button" [ngClass]="{'disabled': apiBeingCalled}" class="btn  btn-primary w70"
    (click)="saveUsers()">Save</button>
</div>
